// Read-only subset of whatsapp-console-frontend
// `src/pages/AdTemplates/adVariantFormat.js`.
import { AdTemplateVariant } from './adTemplateIdeas';

export const DASH = '—';

export const currencySymbol = (currency?: string): string =>
  currency === 'USD' ? '$' : '₹';

export const fmtAge = (variant: AdTemplateVariant): string => {
  const min = Number(variant.minAge) || 0;
  const max = Number(variant.maxAge) || 0;
  if (!min && !max) {
    return DASH;
  }
  return `${min || 18}–${max >= 65 ? '65+' : max}`;
};

export const variantGeoLabels = (variant: AdTemplateVariant): string[] =>
  (variant.geoLocationDisplay || [])
    .map((place) => place.name || place.key)
    .filter(Boolean);

export const variantCurrency = (variant: AdTemplateVariant): string =>
  (variant.prediction && variant.prediction.currency) || 'INR';

export const variantBudget = (
  variant: AdTemplateVariant,
): { amount: number; isLifetime: boolean } => {
  const isLifetime = variant.budgetType === 'lifetime_budget';
  const selected = variant.selected || {};
  const amount = isLifetime
    ? Number(selected.lifetimeBudget) || 0
    : Number(selected.dailyBudget) || Number(variant.dailyBudget) || 0;
  return { amount, isLifetime };
};
